export default __webpack_public_path__ + "static/media/search-dark.6e364817.svg";